import React from 'react';
import { PRIVACY, TERMS } from '../lib/legal';

/* /privacy and /terms — readable without signing in. */
export default function Legal({ which }) {
  const doc = which === 'terms' ? TERMS : PRIVACY;
  const other = which === 'terms' ? ['/privacy', 'Privacy Policy'] : ['/terms', 'Terms of Use'];
  return (
    <div className="legal">
      <a className="legal-home" href="/">← Builders' Network</a>
      <h1>{doc.title}</h1>
      <p className="muted-sm">Last updated {doc.updated}</p>
      <p>{doc.intro}</p>
      {doc.sections.map(([heading, items]) => (
        <section key={heading}>
          <h2>{heading}</h2>
          <ul>{items.map((t) => <li key={t}>{t}</li>)}</ul>
        </section>
      ))}
      <p className="muted-sm"><a href={other[0]}>{other[1]}</a></p>
    </div>
  );
}
